import { useState } from "react";
import { useDispatch } from "react-redux";
import Select from "react-select";
import { Box, Card, DialogTitle, FormControl, FormControlLabel, DialogContent, IconButton, TextField, Typography, RadioGroup, Radio, DialogActions, CircularProgress } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import MDButton from "components/MDButton";
import { grey } from '@mui/material/colors';
import { addAgingRule, updateAgingRule } from "../../redux/slices/hyperwolf/inventoryDistribution";
import { showToastMsg } from "components/distributionSetting/distributionManagement/addRegionKit";

export default function AddAgingRule({ closeModal, modalData }) {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [selectedRule, setSelectedRule] = useState("productExpiringDays");
  // const [selectedRule, setSelectedRule] = useState(modalData?.rule?.productExpiringDays ? "productExpiringDays" : "productOlderDays")
  const [errors, setErrors] = useState({});
  const [details, setDetails] = useState(modalData?.rule ? {
    categoryId: modalData?.rule?.categoryId || "",
    productExpiringDays: modalData?.rule?.productExpiringDays || "",
    productOlderDays: modalData?.rule?.productOlderDays || "",
    id: modalData?.rule?._id || ""
  } : {});

  const handleChange = (e) => {
    const { name, value } = e.target;
    const numOnly = value.replace(/[^0-9]/g, "");
    setDetails(prev => ({ ...prev, [name]: numOnly }));
  }

  const isValid = () => {
    const myErrors = {}
    if (!details.categoryId) {
      myErrors.categoryId = "Please select category"
    }
    if (!Number(details.productOlderDays) && !Number(details.productExpiringDays)) {
      myErrors.rule = "Please enter value to create a rule"
    }

    const hasError = Object.values(myErrors || {}).filter(Boolean)?.length
    return hasError ? myErrors : false
  }

  const handleAddOrUpdateRule = async () => {
    try {
      if (isLoading) return;
      const hasError = isValid();
      if (hasError) {
        setErrors(hasError);
        return;
      } else {
        setErrors({});
      }
      setIsLoading(true);

      const request = {
        ...details,
        productExpiringDays: details.productExpiringDays || 0,
        productOlderDays: details.productOlderDays || 0
      }

      let response = {}
      if (details.id) {
        response = await dispatch(updateAgingRule(request)).unwrap();
      } else {
        response = await dispatch(addAgingRule(request)).unwrap();
      }
      setIsLoading(false);
      if (response?.data && modalData?.setRefreshRules) {
        modalData?.setRefreshRules(prev => !prev)
      };

      showToastMsg(response?.message || "Success", "success")
      closeModal();
    } catch (error) {
      setIsLoading(false);
      showToastMsg(error, "error")
    }
  }

  return (
    <Card sx={{ py: 3, px: 4, borderRadius: 0 }}>
      <DialogTitle id='draggable-dialog-title' sx={{ p: 0, mb: 2 }} display='flex' alignItems='center' justifyContent='space-between'>
        {modalData?.rule ? "Edit" : "Add"} Aging Rule By Category
        <IconButton onClick={closeModal} edge='end' size='small' className='modal-close'>
          <CloseIcon fontSize='medium' />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Box>
          <Typography variant='body2' fontWeight="medium" color={grey[600]} mb={1}>Select Category</Typography>
          <FormControl fullWidth>
            <Select
              classNamePrefix="form-select"
              name="categoryId"
              value={modalData?.categories?.find(cat => cat.id === details.categoryId) || null}
              onChange={option => setDetails(prev => ({ ...prev, categoryId: option ? option.id : "" }))}
              options={modalData?.categories || []}
              getOptionLabel={option => option.name}
              getOptionValue={option => option.id}
              placeholder="Select Category"
              className='cus-react-select'
              styles={{
                menuPortal: base => ({
                  ...base,
                  zIndex: 99999999,
                })
              }}
              menuPortalTarget={document.body}
              components={{
                IndicatorSeparator: null
              }}
            />
            {errors?.categoryId && <p className="error">{errors?.categoryId}</p>}
          </FormControl>
        </Box>
        <FormControl fullWidth>
          <RadioGroup
            row
            aria-labelledby='demo-row-radio-buttons-group-label'
            name=''
            className='modal-radio text-black-600'
            onChange={e => {
              const { value } = e.target;
              setSelectedRule(value)
              if (value === "productExpiringDays") {
                setDetails(prev => ({ ...prev, productOlderDays: 0 }))
              } else {
                setDetails(prev => ({ ...prev, productExpiringDays: 0 }))
              }
            }}
          >
            {/* <div className="radio-rep">
                            <FormControlLabel value='productOlderDays' checked={selectedRule === "productOlderDays"} className='text-black-600' control={<Radio className="p-0" />} label='Product Older Than' />
                            <div className="radio-input">
                                <TextField
                                    label=""
                                    className="form-input"
                                    fullWidth
                                    placeholder=""
                                    disabled={selectedRule !== "productOlderDays"}
                                    name="productOlderDays"
                                    value={details.productOlderDays || ""}
                                    onChange={handleChange}
                                />
                                <span>Days</span>
                            </div>
                        </div> */}
            <div className="radio-rep">
              <FormControlLabel value='productExpiringDays' checked={selectedRule === "productExpiringDays"} className='text-black-600' control={<Radio className="p-0" />} label='Product Expiring In' />
              <div className="radio-input">
                <TextField
                  label=""
                  className="form-input"
                  fullWidth
                  placeholder=""
                  disabled={selectedRule !== "productExpiringDays"}
                  name="productExpiringDays"
                  value={details.productExpiringDays || ""}
                  onChange={handleChange}
                />
                <span>Days</span>
              </div>
            </div>
          </RadioGroup>
        </FormControl>
        {errors?.rule && <p className="error">{errors?.rule}</p>}
      </DialogContent>

      {/* Action buttons */}
      <DialogActions>
        <MDButton
          color="primary"
          type="button"
          variant="contained"
          sx={{ minWidth: '160px', height: "44px" }}
          disabled={isLoading}
          onClick={handleAddOrUpdateRule}
        >
          {isLoading ? <CircularProgress size={22} color="light" /> : "Save"}
        </MDButton>
        <MDButton
          onClick={closeModal}
          type='button'
          variant='outlined'
          color='dark'
          sx={{ minWidth: '160px', height: "44px" }}
        >
          Cancel
        </MDButton>
      </DialogActions>
    </Card>
  )
}